import React, { useContext, useState } from "react";
import { FadeComponent } from "../fadediv/FadeComponent";
import Utils from "../../utils/Utils";
import { LoaderView } from "../loader/Loader";
import { AppContext } from "../../context/state";
export const PassingStats = ({ show = true }) => {
  const [loaderStatus, setLoaderStatus] = useState(true);
  const { store } = useContext(AppContext);
  const pageUrl = "/api/explained/sq-passing-points";

  return (
    <FadeComponent show={show}>
      <>
        <div className="Aboutside">
          <div className="container stats-explained">
            <h2 style={{ marginBottom: "30px" }}>SQAssists</h2>

            <div className="gray-background-container">
              <h5 className="sq-points-tittle" style={{ marginBottom: "30px" }}>
                SQAssists
              </h5>

              <p>There are three reasons why assists are a bad representation of passing:</p>
              <ul className="list">
                <li>
                  It puts too much value on the shooter making the shot rather than the pass itself. It could be an
                  incredible pass to a wide open layup that the player misses and the passer gets no credit.
                </li>
                <li>
                  A pass to a three point shot is more valuable than a pass to a two pointer, but an assist counts them
                  equally.
                </li>
                <li>Assists ignore passes that lead to fouls drawn.</li>
              </ul>
              <br />
              <div className="row pt-0">
                <div className="col-lg-12">
                  <p>
                    There are certain assists that lead to improbable shots that go in, and conversely, passes to great
                    shots that are missed. SQ Assists dispel of those confounding and lucky factors and delivers one of
                    the most advanced indicative assisting statistics.
                  </p>
                  <p>
                    <b>The SQ assist is calculated using probability:</b>
                  </p>

                  <p>
                    If Player X made a pass for a wide open layup that goes in 90% of the time. Then Player X would be
                    credited with .9 of an SQ assist, regardless if the teammate made or missed the shot.
                  </p>
                  <p>
                    Or, if Player X made a pass to a contested midrange that goes in 20% of the time. Then, Player X
                    would get credited with .2 of an SQ assist, regardless if the teammate made or missed the shot.
                  </p>
                  <p>
                    The SQ assist is the total accumulation of the probability each pass had of going and rounded to the
                    nearest whole number!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="Aboutside" style={{ marginBottom: "150px" }}>
          <div className="container stats-explained">
            {/* {store.leagueType !== "wnba" && (
              <div className="gray-background-container" style={{ marginBottom: "60px" }}>
                <h5 className="sq-points-tittle" style={{ marginBottom: "30px" }}>
                  SQ Passing Points Created
                </h5>

                <p>
                  A major fault of the traditional assist stat is that it doesn’t count the amount of points that comes
                  from the passes. SQ Passing Points Created sums up the SQ points that were accumulated. This number
                  will be a little more challenging to conceptualize, however, you should try because it is the
                  prememint passing statistic for three reasons: in that it counts all passes, regardless of makes or
                  misses, it accounts for the amount of points derived from the passes, and counts passes that lead to
                  fouls (fixes all three of the major biases that are inhibiting the conventional assist).
                </p>
                <p>
                  <b>Let’s say Player X make 2 passes:</b>
                </p>
                <ul>
                  <li>He passes to a missed wide open 3, which has an SQpoints value of 1.25</li>
                  <li>And he passes to missed layup, which has an SQpoints value of 1.6</li>
                  <li>Player X for that game would have 2.85 SQ assisted points.</li>
                </ul>
              </div>
            )} */}
            <div className="contact-info">
              <p>Have a question or suggestion?</p>
              <a href="mailto:hello@shotquality.com">Contact Us</a>
            </div>
          </div>
        </div>

        {
          // <div className="question text-center">
          //   <div className="row align-items-center pt-0">
          //     <div className="col-md-5 order-md-2">
          //       <div className="form-group w-100">
          //         <a href="mailto:hello@shotquality.com">
          //           <i className="fa fa-envelope" aria-hidden="true" />{" "}
          //           hello@shotquality.com
          //         </a>
          //       </div>
          //     </div>
          //     <div className="col-md-7 order-md-1">
          //       <div className="row pt-0">
          //         <div className="form-group col-sm-6">
          //           <a
          //             href="mailto:hello@shotquality.com?Subject=Suggestion"
          //             className="btn btn-primary w-100"
          //           >
          //             Suggestion
          //           </a>
          //         </div>
          //         <div className="form-group col-sm-6">
          //           <a
          //             href="mailto:hello@shotquality.com?Subject=Question"
          //             className="btn btn-primary w-100"
          //           >
          //             question ?
          //           </a>
          //         </div>
          //       </div>
          //     </div>
          //   </div>
          // </div>
        }
      </>
    </FadeComponent>
  );
};
